import { setWorkerUrl } from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

// MapLibre 6 はワーカーを別配信するため、Vite が生成した URL を地図の生成前に設定する。
setWorkerUrl(workerUrl);
